export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/sendcredentials',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allSchools'],
    })
